/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Irrigation_Run_MissedInputs */

const vi_error_irrigation_run_missed = /** @type {(inputs: Error_Irrigation_Run_MissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lỡ giờ hơn 2 phút nên phiên này bị bỏ qua`)
};

/**

* @param {Error_Irrigation_Run_MissedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_irrigation_run_missed = /** @type {((inputs?: Error_Irrigation_Run_MissedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Irrigation_Run_MissedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_irrigation_run_missed(inputs)
});